import { Component, inject } from '@angular/core';

import { BrandService } from '../core/services/brand.service';

@Component({
  selector: 'app-portal-footer',
  standalone: true,
  template: `
    <footer class="portal-footer">
      <div class="container py-4">
        <div class="row gy-3 justify-content-between">
          <div class="col-md-6">
            <div class="footer-heading">{{ brandService.brand.name }}</div>
            <div class="footer-line">{{ brandService.brand.addressLine1 }}</div>
            <div class="footer-line">{{ brandService.brand.addressLine2 }}</div>
          </div>
          <div class="col-md-6 text-md-end">
            <div class="footer-heading">Contact</div>
            <div class="footer-line">
              <a [href]="brandService.brand.phoneHref">{{ brandService.brand.phone }}</a>
            </div>
            <div class="footer-line">
              <a [href]="'mailto:' + brandService.brand.helpEmail">{{ brandService.brand.helpEmail }}</a>
            </div>
            <div class="footer-line">
              <a [href]="brandService.brand.website" target="_blank" rel="noopener">{{ websiteLabel }}</a>
            </div>
          </div>
        </div>
        <hr class="footer-divider" />
        <div class="text-center small">
          &copy; {{ year }} {{ brandService.brand.name }}. All rights reserved.
        </div>
      </div>
    </footer>
  `,
  styles: [
    `
      .portal-footer {
        background-color: var(--portal-primary);
        color: #d9dde8;
      }
      .portal-footer .footer-heading {
        font-weight: 600;
        color: #fff;
        margin-bottom: 0.5rem;
        letter-spacing: 0.03em;
      }
      .portal-footer .footer-line {
        font-size: 0.925rem;
        line-height: 1.5;
      }
      .portal-footer a {
        color: var(--portal-chrome-link);
        text-decoration: none;
      }
      .portal-footer a:hover {
        color: var(--portal-chrome-link-hover);
        text-decoration: underline;
      }
      .portal-footer .footer-divider {
        border-color: rgba(255, 255, 255, 0.15);
        margin: 1.25rem 0 0.75rem;
      }
    `,
  ],
})
export class PortalFooterComponent {
  protected brandService = inject(BrandService);

  year = new Date().getFullYear();

  get websiteLabel(): string {
    return this.brandService.brand.website.replace('https://', '');
  }
}
